import useNavigation from '@/hooks/useNavigation';

import { useAdminRoute } from '../useAdminRoutes';

const usePreviewRoute = () => {
  const navigation = useNavigation();
  const isAdminRoute = useAdminRoute();

  const isPreviewRoutes =
    navigation.asPath.includes('/preview') || navigation.asPath.includes('/preview-devices');

  return Boolean(isAdminRoute && isPreviewRoutes);
};

export { usePreviewRoute };
